module.exports = __webpack_public_path__ + "126b7c8ff85935e7dcb36962f94830e5.svg";